import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const ExpensePieChart = ({ totals,attributes }) => {
    if (!totals) {
        return <p>No data available</p>; // ✅ If null, don't proceed
    }

    const filteredEntries = Object.entries(totals).filter(([key]) => key !== 'total');

    // Calculate total sum of values
    const totalSum = filteredEntries.reduce((sum, [, value]) => sum + value, 0);

    if (totalSum === 0) {
        return <p>No data to display</p>; // ✅ If total is zero, stop here
    }

    const data = {
        labels: filteredEntries.map(([key]) => key.charAt(0).toUpperCase() + key.slice(1)),
        datasets: [
            {
                data: filteredEntries.map(([_, value]) => value),
                backgroundColor: ['#4cafef', '#ff9800', '#4caf50'],
                borderWidth: 1
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'top' },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let value = context.raw || 0;
                        return `${attributes?.currency + " "}${value.toLocaleString()}`;
                    }
                }
            }
        }
    };

    return (
        <div style={{ height: '300px' }}>
            <Pie data={data} options={options} />
        </div>
    );
};

export default ExpensePieChart;
